
export const GET_PUR_REQUEST = "GET_PUR_REQUEST";
export const GET_PUR_SUCCESS = "GET_PUR_SUCCESS";
export const GET_PUR_FAILURE = "GET_PUR_FAILURE";